import moment from "moment";
import * as yup from "yup";
import { MAX_FILE_SIZE, MAX_FILE_SIZE_MESSAGE } from "./fileValidationRules";

export const validFileExtensions = {
   image: ["jpg", "gif", "png", "jpeg", "svg", "webp", "pdf"],
   document: ["pdf", "doc", "docx"],
   all: ["jpg", "gif", "png", "jpeg", "svg", "webp", "pdf", "doc", "docx"],
};

export function isValidFileType(fileName, fileType) {
   return (
      fileName && validFileExtensions[fileType].indexOf(fileName.split(".").pop()) > -1
   );
}

export function getAllowedExt(type) {
   return validFileExtensions[type].map((e) => `.${e}`).toString();
}

const validation = {
   amount: (fieldName = "amount", required = true) =>
      yup
         .string()
         .matches(/^\d+(\.\d{1,2})?$/, `Invaid ${fieldName}!`)
         .when({
            is: () => required,
            then: (schema) => schema.required(`${fieldName} is required.`),
            otherwise: (schema) => schema.notRequired(),
         }),

   name: (fieldName = "name", required = true) =>
      yup
         .string()
         .matches(/^[a-zA-Z][a-zA-Z-' ]{1,50}[a-zA-Z]$/, `Invalid ${fieldName}`)
         .when({
            is: () => required,
            then: (schema) => schema.required(`${fieldName} is required.`),
            otherwise: (schema) => schema.notRequired(),
         }),

   mobile: yup
      .string()
      .required("Mobile number is required.")
      .matches(/^[0-9]{10,15}$/, "Invalid phone number"),

   email: yup.string().email("Invalid email address").required("Email is required."),

   address: (fieldName = "Address", required = true) =>
      yup.string().when({
         is: () => required,
         then: (schema) => schema.required(`${fieldName} is required.`),
         otherwise: (schema) => schema.notRequired(),
      }),

   accountNumber: (required = true) =>
      yup
         .string()
         .matches(/^\d{9,18}$/, "Invalid account number")
         .when({
            is: () => required,
            then: (schema) => schema.required("Account number is required."),
            otherwise: (schema) => schema.notRequired(),
         }),

   bankName: (required = true) =>
      yup
         .string()
         .matches(/^[a-zA-Z][a-zA-Z-' ]{1,50}[a-zA-Z]$/, "Invalid bank name!")
         .when({
            is: () => required,
            then: (schema) => schema.required("Bank name is required."),
            otherwise: (schema) => schema.notRequired(),
         }),

   ifscCode: (required = true) =>
      yup.string().when({
         is: () => required,
         then: (schema) => schema.required("IFSC code is required."),
         otherwise: (schema) => schema.notRequired(),
      }),

   gstNumber: yup
      .string()
      .required("GST number is required.")
      .matches(
         /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
         "Invalid GST number!"
      ),

   panNo: yup.string().matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invaid pan card no!"),

   aadharNo: yup
      .string()
      .required("Aadhar Number is required")
      .matches(/^[2-9]{1}[0-9]{11}$/, "Invalid aadhar card no!"),

   dob: yup
      .string()
      .required("DOB is required")
      .test("is-past", "Date must be in the past", function (value) {
         // Parse the date string using Moment.js and check if it's in the past
         const date = moment(value, "YYYY-MM-DD");
         return date.isValid() && date.isBefore(moment(), "years");
      })
      .test("is-before-2999", "Date must be before 31-12-2999", function (value) {
         // Parse the date string using Moment.js and check if it's in the past
         const date = moment(value, "YYYY-MM-DD");
         return date.isValid() && date.isBefore(moment("2999-12-31"), "years");
      }),

   hour: (fieldName = "name", required = true) =>
      yup
         .string()
         .matches(/^[1-9]\d*$/, `Invalid ${fieldName}`)
         .when({
            is: () => required,
            then: (schema) => schema.required(`${fieldName} is required.`),
            otherwise: (schema) => schema.notRequired(),
         }),

   file: (fieldName = "name", required = true, documentType = "image") =>
      yup
         .mixed()
         .test(
            "is-valid-type",
            `Not a valid ${documentType === "image" ? "image" : "document"} type`,
            (value) => {
               if (value) {
                  if (typeof value === "string") {
                     return true;
                  } else {
                     return isValidFileType(value?.name?.toLowerCase(), documentType);
                  }
               } else {
                  return true;
               }
            }
         )
         .test("is-valid-size", MAX_FILE_SIZE_MESSAGE, (value) => {
            if (value) {
               if (typeof value === "string") {
                  return true;
               } else {
                  return value?.size <= MAX_FILE_SIZE;
               }
            } else {
               return true;
            }
         })
         .when({
            is: () => required,
            then: (schema) => schema.required(`${fieldName} is required.`),
            otherwise: (schema) => schema.notRequired(),
         }),
};

export default validation;
